import { get, trim } from 'lodash';

class Zone {
  constructor() {
    this.zoneMap = {
      zone_group_no: 'Zone.ZoneGroup.Id',
      zone_no: 'Zone.Id',
    };
  }

  map(zones) {
    if (zones === undefined) {
      return [];
    }

    let theZones = [];
    for (let x = 0; x < zones.length; x++) {
      let zone = {};
      for (let p in this.zoneMap) {
        zone[p] = trim(get(zones[x], this.zoneMap[p]));
      }
      theZones.push(zone);
    }

    return theZones;
  }
}

export default Zone;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/Zone.js